"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restPropsGeneralDefaults = exports.restPropsGeneralShape = exports.modeShape = exports.selectedShape = exports.NUMBER_OR_STRING = exports.dividerShape = exports.stringOrNumber = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RADIO = _constants.MODE.RADIO,
    CHECKBOX = _constants.MODE.CHECKBOX;

var stringOrNumber = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);

exports.stringOrNumber = stringOrNumber;

var dividerShape = _propTypes.default.shape({
  dividerClass: _propTypes.default.string,
  dividerPosition: _propTypes.default.oneOf([_constants.DIVIDER_POSITIONS.TOP, _constants.DIVIDER_POSITIONS.BOTTOM]),
  dividerStyle: _propTypes.default.object
});

exports.dividerShape = dividerShape;

var NUMBER_OR_STRING = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);

exports.NUMBER_OR_STRING = NUMBER_OR_STRING;

var selectedShape = _propTypes.default.oneOfType([NUMBER_OR_STRING, _propTypes.default.arrayOf(NUMBER_OR_STRING)]);

exports.selectedShape = selectedShape;

var modeShape = _propTypes.default.oneOf([RADIO, CHECKBOX]);

exports.modeShape = modeShape;
var restPropsGeneralShape = {
  minimumSearchLetters: _propTypes.default.number,
  minHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
exports.restPropsGeneralShape = restPropsGeneralShape;
var restPropsGeneralDefaults = {
  minimumSearchLetters: 2,
  minHeight: null,
  maxHeight: null,
  height: null
};
exports.restPropsGeneralDefaults = restPropsGeneralDefaults;
//# sourceMappingURL=shapes.js.map